import script from "./TrackYourSpendPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrackYourSpendPage.vue?vue&type=script&setup=true&lang=ts"

import "./TrackYourSpendPage.vue?vue&type=style&index=0&id=64cefe9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64cefe9a"]])

export default __exports__